// ********** ********** ********** ********** ********** ********** ********** ********** ********** 将当前选中的颜色变体名动态显示在变体标题旁

document.addEventListener("DOMContentLoaded", function () {
  var productJson = JSON.parse(
    document.querySelector('script[type="application/json"]').textContent
  );
  var colorFieldset = document.querySelector(".product-form__colors");

  if (colorFieldset) {
    var colorInputs = colorFieldset.querySelectorAll('input[type="radio"]');
    var selectedColorSpan = document.getElementById("selectedColor");

    function updateSelectedColor(event) {
      var selectedColor = event.target.value;
      selectedColorSpan.textContent = " - " + selectedColor;
    }

    colorInputs.forEach(function (input) {
      input.addEventListener("change", updateSelectedColor);
    });

    // Initialize with the current selection
    var checkedInput = colorFieldset.querySelector(
      'input[type="radio"]:checked'
    );
    if (checkedInput) {
      selectedColorSpan.textContent = " - " + checkedInput.value;
    }
  }
});

// ********** ********** ********** ********** ********** ********** ********** ********** ********** 根据选择的变体  控制 "48小时发货的tag和提交" "定制详情"

document.addEventListener("DOMContentLoaded", function () {
  const SELECTORS = {
    icon48hrs: "#icon-48hrs",
    icon48hrsL: "#icon48hrsL",
    productionTime: "#production-time",
    customColorDetail: "#customColor-detail",
    optionColorContainer: "#option-color",
    sizeOptsContainer: "#sizeOpts",
    ship48HrsInput: "#ship48Hrs",
    customColorLabel: 'label[data-swatch="custom-color"]',
    customSizeInput: 'input[value="Custom Size"]',
  };

  const elements = {};
  Object.keys(SELECTORS).forEach(function (key) {
    elements[key] = document.querySelector(SELECTORS[key]);
  });

  const has48HrsElements = !!elements.icon48hrs;

  function updateElementsVisibility() {
    var customColorInput =
      elements.customColorLabel &&
      elements.customColorLabel.previousElementSibling;
    var isCustomColorSelected = customColorInput && customColorInput.checked;
    var isCustomSizeSelected =
      elements.customSizeInput && elements.customSizeInput.checked;

    // 控制 customColor-detail 的显示/隐藏（所有页面都需要）
    if (elements.customColorDetail) {
      elements.customColorDetail.style.display = isCustomColorSelected
        ? "block"
        : "none";
    }

    var shouldHideAndDisable = isCustomColorSelected || isCustomSizeSelected;

    if (has48HrsElements) {
      // 在有 48 小时相关元素的页面上
      elements.icon48hrs.style.display = shouldHideAndDisable ? "none" : "";
      elements.icon48hrsL.style.display = shouldHideAndDisable ? "none" : "";
      elements.productionTime.style.display = shouldHideAndDisable
        ? ""
        : "none";

      // 控制 ship48HrsInput 的提交
      if (elements.ship48HrsInput) {
        elements.ship48HrsInput.name = shouldHideAndDisable
          ? "disabled_" + elements.ship48HrsInput.getAttribute("data-ship-name")
          : elements.ship48HrsInput.getAttribute("data-ship-name");
      }
    } else {
      // 在没有 48 小时相关元素的页面上，始终显示 productionTime
      if (elements.productionTime) {
        elements.productionTime.style.display = "";
      }
    }
  }

  function handleInputChange(event) {
    if (
      event.target.closest(SELECTORS.optionColorContainer) ||
      event.target.closest(SELECTORS.sizeOptsContainer)
    ) {
      updateElementsVisibility();
    }
  }

  document.body.addEventListener("change", handleInputChange);

  document.body.addEventListener("touchend", function (event) {
    if (event.target.type === "radio") {
      event.preventDefault();
      event.target.checked = true;
      handleInputChange(event);
    }
  });

  // 初始化元素状态
  updateElementsVisibility();
});

// ********** ********** ********** ********** ********** ********** ********** ********** ********** 当点击颜色变体时，主图区同步显示当前选择的变图图片

document.addEventListener("DOMContentLoaded", function () {
  const variantSelectors = document.querySelectorAll("[data-swatch]");
  const galleryContainer = document.querySelector(".cs-product-media-gallery");
  const gallery = galleryContainer
    ? new CSProductMediaGallery(galleryContainer)
    : null;

  variantSelectors.forEach((selector) => {
    selector.addEventListener("click", function (event) {
      const mediaId = this.getAttribute("data-media-id");
      if (mediaId && gallery) {
        const thumbnailIndex = Array.from(gallery.thumbnails).findIndex(
          (thumb) => thumb.getAttribute("data-media-id") === mediaId
        );
        if (thumbnailIndex !== -1) {
          gallery.setActiveImage(thumbnailIndex);
        }
      }
    });
  });

  // Add this method to the CSProductMediaGallery class
  CSProductMediaGallery.prototype.setActiveImageByMediaId = function (mediaId) {
    const thumbnailIndex = Array.from(this.thumbnails).findIndex(
      (thumb) => thumb.getAttribute("data-media-id") === mediaId
    );
    if (thumbnailIndex !== -1) {
      this.setActiveImage(thumbnailIndex);
    }
  };

  // Expose the gallery instance globally for potential use in other scripts
  window.productGallery = gallery;
});

// ********** ********** ********** ********** ********** ********** ********** ********** ********** 尺码选择模块

(function () {
  "use strict";

  const DEFAULT_SIZE = "US0";
  const UNITS = { INCH: "inch", CM: "cm" };

  let selectedSize = DEFAULT_SIZE;
  let currentUnit = UNITS.INCH;

  const elements = {
    sizeOpts: document.getElementById("sizeOpts"),
    selectedSizeDisplay: document.getElementById("selectedSize"),
    unitSwitch: document.getElementById("unitSwitch"),
    unitSubmit: document.getElementById("unitSubmit"),
    inUnit: document.getElementById("inUnit"),
    cmUnit: document.getElementById("cmUnit"),
    sizeChartBody: document.querySelector("#sizeChart tbody"),
    sizeData: document.getElementById("sizeData"),
    customerData: document.getElementById("customerData"),
    customSizeUnits: document.querySelectorAll("#customerData .unit"),
    customSizeInputs: document.querySelectorAll("#customerData [data-custom-data]"),
  };

  const sizeRows = Array.from(elements.sizeChartBody.querySelectorAll("tr"));
  const sizesArray = sizeRows.map((row) => row.dataset.size);

  function updateUI() {
    const isCustomSize = selectedSize === "Custom Size";

    // Update size options
    elements.sizeOpts.querySelectorAll(".size-button").forEach((label) =>
      label.classList.toggle("selected", label.dataset.size === selectedSize)
    );

    // Update size chart
    elements.sizeData.classList.toggle("hidden", isCustomSize);
    elements.customerData.classList.toggle("hidden", !isCustomSize);

    if (!isCustomSize) {
      const visibleRows = getVisibleRows();
      sizeRows.forEach((row) => {
        const size = row.dataset.size;
        const isVisible = visibleRows.includes(size);
        row.style.display = isVisible ? "table-row" : "none";
        row.classList.toggle("selected", size === selectedSize);
        if (isVisible) {
          row.querySelectorAll("td:not(:first-child)").forEach((cell) => {
            cell.textContent = `${cell.dataset[currentUnit]} ${currentUnit}`;
          });
        }
      });
    }

    // Update custom size inputs
    elements.customSizeInputs.forEach((element) => {
      const customData = element.getAttribute('data-custom-data');
      element.name = isCustomSize ? customData : customData.replace('properties', 'disabled_properties');
    });

    // Update units
    elements.customSizeUnits.forEach((span) => (span.textContent = currentUnit));
    elements.unitSubmit.value = currentUnit === UNITS.INCH ? "Inch" : "CM";
  }

  function getVisibleRows() {
    const selectedIndex = sizesArray.indexOf(selectedSize);
    if (selectedIndex <= 0) return sizesArray.slice(0, 3);
    if (selectedIndex === sizesArray.length - 1) return sizesArray.slice(-3);
    return sizesArray.slice(selectedIndex - 1, selectedIndex + 2);
  }

  function toggleUnit() {
    currentUnit = elements.unitSwitch.checked ? UNITS.CM : UNITS.INCH;
    const isInch = currentUnit === UNITS.INCH;
    elements.inUnit.style.fontWeight = isInch ? "bold" : "normal";
    elements.inUnit.style.color = isInch ? "#bf0008" : "#333";
    elements.cmUnit.style.fontWeight = isInch ? "normal" : "bold";
    elements.cmUnit.style.color = isInch ? "#333" : "#bf0008";
    updateUI();
  }

  function init() {
    document.addEventListener("change", (event) => {
      const target = event.target;
      if (target.id === "unitSwitch") {
        toggleUnit();
      } else if (target.name === "properties[Size]") {
        selectedSize = target.value;
        elements.selectedSizeDisplay.textContent = `- ${selectedSize}`;
        updateUI();
      }
    });

    // 初始化时不需要调用 updateUI，因为 CSS 已经设置了初始状态
    // 但我们仍然需要设置单位和自定义尺寸输入字段
    elements.customSizeUnits.forEach((span) => (span.textContent = currentUnit));
    elements.unitSubmit.value = "Inch";
    elements.customSizeInputs.forEach((element) => {
      const customData = element.getAttribute('data-custom-data');
      element.name = customData.replace('properties', 'disabled_properties');
    });
  }

  init();
})();

// ********** ********** ********** ********** ********** ********** ********** ********** ********** 运输方式 时效预览

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".ship-opt-bt");
  const shippingDays = document.getElementById("shipping-days");
  const selSlider = document.querySelector(".ship-sel-slider");
  const freeShipTips = document.getElementById("free-ship-tips");

  function updateSelectedShipOpt(selShips) {
    buttons.forEach((btn, index) => {
      const isSelected = btn === selShips;
      btn.classList.toggle("selected", isSelected);
      if (isSelected) {
        selSlider.style.transform = `translateX(${index * 100}%)`;
        freeShipTips.style.display = index === 0 ? "block" : "none";
        shippingDays.textContent = btn.getAttribute("data-ship-time");
      }
    });
  }

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      updateSelectedShipOpt(this);
    });
  });

  // 初始化选中状态
  updateSelectedShipOpt(buttons[0]);
});

// ********** ********** ********** ********** ********** ********** ********** ********** **********
// ********** ********** ********** ********** ********** ********** ********** ********** **********
// ********** ********** ********** ********** ********** ********** ********** ********** **********
// ********** ********** ********** ********** ********** ********** ********** ********** **********
